__turbopack_context__.v({
  "cell": "collections-saved-searches-module-scss-module__vBKQKa__cell",
  "empty": "collections-saved-searches-module-scss-module__vBKQKa__empty",
  "grid": "collections-saved-searches-module-scss-module__vBKQKa__grid",
  "pagination": "collections-saved-searches-module-scss-module__vBKQKa__pagination",
  "state": "collections-saved-searches-module-scss-module__vBKQKa__state",
});
